// 商品一覧の無限スクロール
// [data-cz-grid] の data-next-url（次のページの URL）を読み込み、同じ格子の中身を末尾に足す。
// 次のページが無くなったら終わり。JavaScript が動かない環境では下のページ送りのリンクで辿れる。
(function () {
  document.querySelectorAll('[data-cz-grid]').forEach(function (grid) {
    var sentinel = grid.parentElement.querySelector('[data-cz-sentinel]');
    var pager = grid.parentElement.querySelector('[data-cz-pager]');
    if (!sentinel || !('IntersectionObserver' in window)) return;
    if (pager) pager.hidden = true;
    var loading = false;

    function done() {
      sentinel.classList.remove('is-loading');
      sentinel.textContent = sentinel.getAttribute('data-done-text') || '';
      io.disconnect();
    }

    function loadNext() {
      var next = grid.getAttribute('data-next-url');
      if (!next) { done(); return; }
      if (loading) return;
      loading = true;
      sentinel.classList.add('is-loading');
      fetch(next)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-cz-grid="' + grid.getAttribute('data-cz-grid') + '"]');
          if (!incoming) { grid.removeAttribute('data-next-url'); done(); return; }
          while (incoming.firstElementChild) grid.appendChild(incoming.firstElementChild);
          var nextUrl = incoming.getAttribute('data-next-url');
          if (nextUrl) { grid.setAttribute('data-next-url', nextUrl); } else { grid.removeAttribute('data-next-url'); done(); }
        })
        .catch(function () { if (pager) pager.hidden = false; })
        .finally(function () { loading = false; sentinel.classList.remove('is-loading'); onScroll(); });
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '800px 0px' });
    // IntersectionObserver が届かない環境向けに、スクロール位置でも判定する
    function onScroll() {
      if (!grid.getAttribute('data-next-url')) { window.removeEventListener('scroll', onScroll); return; }
      if (sentinel.getBoundingClientRect().top < window.innerHeight + 800) loadNext();
    }
    if (grid.getAttribute('data-next-url')) {
      io.observe(sentinel);
      window.addEventListener('scroll', onScroll, { passive: true });
    } else { done(); }
  });
})();
